module.exports = __webpack_public_path__ + "img/relaxed-deadlines.e985d632.svg";